import { inject, Injectable } from '@angular/core';
import { TemplateRegistryService, TemplateType } from '@common/services/template-registry.service';
import { I18NextPipe } from 'angular-i18next';
import { ToastService } from 'mbs-ui-kit';

@Injectable({ providedIn: 'root' })
export class JobToastService {
  private readonly i18nPipe = inject(I18NextPipe);
  private readonly templateRegistry = inject(TemplateRegistryService);
  private readonly toastService = inject(ToastService);

  showTransferred(type: TemplateType): void {
    this.toastService.success(
      this.templateRegistry.getTemplate(type),
      this.i18nPipe.transform('toast.success.title', { format: 'capitalize' })
    );
  }
}
